import React, { useEffect } from "react";
import Header from "../../shared/components/common/Header";
import Footer from "../../shared/components/common/Footer";
import ContactDrawer from "../../shared/components/common/ContactDrawer";

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#f3f6f8] min-h-screen">
      <Header />

      <section className="relative min-h-[40vh] flex items-end justify-center px-4 pt-24 pb-10">
        <div className="w-full max-w-5xl bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-8 text-center">
          <p className="text-xs tracking-widest text-gray-500 uppercase">
            Última atualização: janeiro de 2026
          </p>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mt-3">
            Política de Privacidade – Bianco Azure
          </h1>
          <p className="text-sm sm:text-base text-gray-600 mt-4">
            A Bianco Azure valoriza a privacidade e a proteção dos dados pessoais
            de seus usuários, clientes e parceiros.
          </p>
        </div>
      </section>

      <main className="container mx-auto px-4 py-12 max-w-5xl">
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-10">
          <div className="text-gray-700 leading-relaxed space-y-8 text-sm sm:text-base">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                1. Introdução
              </h2>
              <p>
                Ao acessar ou utilizar o site biancoazure.com.br e as soluções
                oferecidas pela Bianco Azure, você concorda com os termos desta
                Política de Privacidade. Recomendamos a leitura atenta deste
                documento para compreender como seus dados são tratados.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                2. Coleta de Dados
              </h2>
              <p>
                A Bianco Azure coleta apenas os dados estritamente necessários
                para a prestação de seus serviços, operação da plataforma e
                cumprimento de obrigações legais.
              </p>
              <p className="mt-4">
                Os dados coletados podem incluir, conforme a interação do usuário
                com o site ou sistemas:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Dados cadastrais (nome, e-mail, telefone, CPF ou CNPJ).</li>
                <li>
                  Dados de clientes, fornecedores e colaboradores inseridos na
                  plataforma.
                </li>
                <li>Informações de acesso e uso do sistema (logs, IP, data e hora).</li>
                <li>
                  Dados comerciais, administrativos, financeiros e operacionais
                  fornecidos pelos usuários.
                </li>
              </ul>
              <p className="mt-4">
                A coleta é sempre limitada à finalidade pretendida, respeitando
                os princípios da necessidade e adequação.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                3. Finalidade do Tratamento de Dados
              </h2>
              <p>
                Os dados pessoais coletados poderão ser utilizados para as
                seguintes finalidades:
              </p>

              <div className="mt-4 space-y-5">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    3.1 Gestão de Relacionamentos
                  </h3>
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li>
                      Facilitar a comunicação entre empresas, clientes,
                      fornecedores e usuários da plataforma.
                    </li>
                    <li>Organizar atendimentos, interações e histórico de relacionamento.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    3.2 Operações Comerciais e Administrativas
                  </h3>
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li>Gestão de vendas, contratos, cadastros e processos internos.</li>
                    <li>Controle de estoque, serviços e operações empresariais.</li>
                    <li>Processamento de transações e geração de documentos administrativos.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    3.3 Gestão Financeira
                  </h3>
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li>Controle de contas a pagar e a receber.</li>
                    <li>
                      Emissão de relatórios financeiros e apoio à conciliação
                      bancária.
                    </li>
                    <li>Apoio a rotinas fiscais, contábeis e administrativas.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    3.4 Segurança da Informação
                  </h3>
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li>
                      Proteção da plataforma contra acessos não autorizados,
                      fraudes e incidentes de segurança.
                    </li>
                    <li>Monitoramento, auditoria e prevenção de atividades suspeitas.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    3.5 Análise e Melhoria dos Serviços
                  </h3>
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li>Geração de relatórios gerenciais e análises estratégicas.</li>
                    <li>
                      Aprimoramento contínuo das funcionalidades, desempenho e
                      experiência do usuário.
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    3.6 Comunicação e Mensageria
                  </h3>
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li>
                      Envio de notificações, avisos operacionais e comunicações
                      relacionadas ao uso do sistema.
                    </li>
                    <li>
                      Integração com serviços de mensageria para comunicação em
                      tempo real.
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                4. Compartilhamento de Dados
              </h2>
              <p>
                A Bianco Azure não comercializa dados pessoais. O compartilhamento
                ocorre apenas quando necessário, nas seguintes situações:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>
                  Cumprimento de obrigações legais ou regulatórias, mediante
                  solicitação de autoridades competentes.
                </li>
                <li>
                  Prestadores de serviços terceirizados, como provedores de
                  hospedagem, infraestrutura, mensageria, segurança e tecnologia,
                  estritamente para execução dos serviços contratados.
                </li>
                <li>
                  Parceiros tecnológicos, quando indispensável à operação da
                  plataforma, sempre observando cláusulas de confidencialidade e
                  proteção de dados.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                5. Integração com Serviços de Terceiros
              </h2>
              <p>
                Para oferecer funcionalidades de comunicação, notificações e
                mensageria em tempo real, a Bianco Azure pode integrar sua
                plataforma a serviços de terceiros. Esses provedores tratam os
                dados conforme suas próprias políticas de privacidade e padrões
                de segurança, sendo utilizados apenas para finalidades
                operacionais.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                6. Armazenamento e Segurança dos Dados
              </h2>
              <p>
                Os dados são armazenados em ambientes controlados e seguros, com
                acesso restrito a pessoas autorizadas. A Bianco Azure adota
                medidas técnicas e administrativas adequadas para proteger os
                dados contra:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Acessos não autorizados.</li>
                <li>Vazamentos.</li>
                <li>Perda, destruição ou alteração indevida.</li>
                <li>Incidentes de segurança da informação.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                7. Direitos dos Titulares dos Dados
              </h2>
              <p>
                Nos termos da LGPD, os titulares dos dados podem exercer, a
                qualquer momento, os seguintes direitos:
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Confirmar a existência de tratamento de dados.</li>
                <li>Acessar seus dados pessoais.</li>
                <li>
                  Solicitar correção de dados incompletos, inexatos ou
                  desatualizados.
                </li>
                <li>
                  Solicitar anonimização, bloqueio ou exclusão de dados
                  desnecessários.
                </li>
                <li>Solicitar portabilidade dos dados.</li>
                <li>Revogar consentimentos, quando aplicável.</li>
              </ul>
              <p className="mt-4">
                Ressalta-se que determinados dados poderão ser mantidos para
                cumprimento de obrigações legais, regulatórias ou contratuais,
                mesmo após solicitação de exclusão.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                8. Alterações nesta Política
              </h2>
              <p>
                Esta Política de Privacidade poderá ser atualizada a qualquer
                momento para refletir melhorias nos serviços, alterações legais
                ou mudanças nos processos internos. Recomendamos a consulta
                periódica deste documento.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">9. Contato</h2>
              <p>
                Para dúvidas, solicitações ou exercício de direitos relacionados
                a esta Política de Privacidade, entre em contato pelos canais
                oficiais disponibilizados no site biancoazure.com.br.
              </p>
            </section>

            <p className="text-xs text-gray-500 pt-6 border-t border-gray-200">
              © 2026 Bianco Azure. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </main>

      <Footer />
      <ContactDrawer message="Vim do site" />
    </div>
  );
}
